import { render, staticRenderFns } from "./statisticsDashboard.vue?vue&type=template&id=722b8954&scoped=true&"
import script from "./statisticsDashboard.vue?vue&type=script&lang=js&"
export * from "./statisticsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./statisticsDashboard.vue?vue&type=style&index=0&id=722b8954&scoped=true&lang=scss&"
import style1 from "./statisticsDashboard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722b8954",
  null
  
)

export default component.exports